import { render, staticRenderFns } from "./ChooseCards.vue?vue&type=template&id=1d7ab698&scoped=true&"
import script from "./ChooseCards.vue?vue&type=script&lang=js&"
export * from "./ChooseCards.vue?vue&type=script&lang=js&"
import style0 from "./ChooseCards.vue?vue&type=style&index=0&id=1d7ab698&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7ab698",
  null
  
)

export default component.exports